import ContentPage from '@app/components/content.page.component';
import { useAuth } from '@app/libs/auth';
import clsx from 'clsx';
import type { ReactNode } from 'react';

type Props = {
    children?: ReactNode;
};

export default function ChapterContentPage({ children }: Props) {
    const { user } = useAuth();

    return (
        <ContentPage
            className={clsx('max-w-full pb-40 pt-[12px] md:max-w-full', {
                relative: !user?.isVipActive,
            })}
        >
            <div className="mx-auto md:max-w-[1024px]">{children}</div>
        </ContentPage>
    );
}
